import React, { useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import ContractTypeFilter from "./ContractTypeFilter";
import Flatpickr from "react-flatpickr";
import AgencyFilter from "./AgencyFilter";
import OffCanvasFilter from "./OffCanvasFilter";

const Filters = ({
  setSearchValue,
  setPage,
  searchValue,
  filterValue,
  setFilterValue,
  setSorted,
}: {
  setSearchValue: (value: string) => void;
  setPage: (page: number) => void;
  searchValue: string;
  filterValue: any;
  setFilterValue: (value: any) => void;
  setSorted: (sorted: any) => void;
}) => {
  const defaultFilterValue = {
    contractType: "",
    agency: "",
    dateRange: {
      fromDate: null,
      toDate: null,
    },
  };
  const [advancedFilter, setAdvancedFilter] = useState(false);

  const clearFilters = () => {
    setFilterValue(defaultFilterValue);
    setSearchValue("");
    setPage(1);
    setSorted([{ id: "createdAt", desc: true }]);
  };

  return (
    <Card>
      <CardBody>
        <Row className="g-3">
          <Col xxl={3} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Search</h6> */}
            <div className="search-box">
              <input
                type="text"
                className="form-control"
                placeholder="Search contracts..."
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setPage(1);
                }}
                value={searchValue}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>
          <Col xxl={2} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Contract Type</h6> */}
            <ContractTypeFilter
              onChange={(value) => {
                setFilterValue({ ...filterValue, contractType: value });
                setPage(1);
              }}
              value={filterValue.contractType}
            />
          </Col>
          <Col xxl={3} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Select Date Range</h6> */}
            {/* @ts-ignore */}
            <Flatpickr
              className="form-control"
              placeholder="Select Date Range"
              options={{
                mode: "range",
                altFormat: "d M, Y",
                dateFormat: "d M, Y",
              }}
              onChange={(e) => {
                if (e[0] && e[1]) {
                  setFilterValue({
                    ...filterValue,
                    dateRange: {
                      fromDate: e[0],
                      toDate: e[1],
                    },
                  });
                  setPage(1);
                }
              }}
              value={[
                filterValue?.dateRange?.fromDate || "",
                filterValue?.dateRange?.toDate || "",
              ]}
            />
          </Col>
          <Col xxl={2} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Select Agency</h6> */}
            <AgencyFilter
              onChange={(value) => {
                setFilterValue({ ...filterValue, agency: value });
                setPage(1);
              }}
              value={filterValue.agency}
            />
          </Col>
          <Col xxl={2} lg={4}>
            {/* <h6 className="text-uppercase fs-12 mb-xxl-4"> {` `}</h6> */}

            <div className="w-100 d-flex gap-2">
              <button
                onClick={() => {
                  setFilterValue(defaultFilterValue);
                  setSearchValue("");
                  setPage(1);
                  setSorted([{ id: "createdAt", desc: true }]);
                }}
                className="btn btn-light material-shadow-none flex-grow-1"
              >
                <i className="ri-restart-line align-bottom me-1"></i> Reset
              </button>
              <Button
                color="primary"
                className="flex-grow-1"
                onClick={() => {
                  setAdvancedFilter(true);
                }}
              >
                <i className="ri-equalizer-line align-bottom me-1"></i>
                Filters
              </Button>
            </div>
          </Col>
        </Row>
      </CardBody>
      <OffCanvasFilter
        show={advancedFilter}
        onCloseClick={() => setAdvancedFilter(false)}
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        setPage={setPage}
        clearFilters={clearFilters}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
      />
    </Card>
  );
};

export default Filters;
